import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import CloseButton from '@/components/common/CloseButton';
import ShowForViews from '@/components/common/ShowForViews';
import UserViewEnums from '@/constants/users/UserViewEnums';
import translate from '@/lib/intl/translate';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import { useTaskServices } from '@/modules/Tasks';

const FORM_CONTROL_LABEL_CLASSES = {
  label: 'type-caption1',
};

type TaskHeaderProps = {
  onClose(...args: unknown[]): unknown;
  task: {
    isCompleted: boolean;
    taskId: string;
  };
};

export default function TaskHeader({ onClose, task }: TaskHeaderProps) {
  const { updateTask } = useTaskServices();
  const [isChecked, setIsChecked] = React.useState(task.isCompleted);
  const [isUpdating, setIsUpdating] = React.useState(false);

  const handleChange = React.useCallback(async () => {
    if (isUpdating) {
      return;
    }

    setIsUpdating(true);
    setIsChecked(!isChecked);
    try {
      await updateTask({ taskId: task.taskId, isCompleted: !task.isCompleted });
    } catch (e) {
      // do something with error?
    } finally {
      setIsUpdating(false);
    }
  }, [isUpdating, task]);

  return (
    <FormGroup row className="relative -mt-3 mb-2">
      <FormControlLabel
        classes={FORM_CONTROL_LABEL_CLASSES}
        control={
          <ShowForViews
            showFor={[UserViewEnums.ADMIN, UserViewEnums.EDITOR]}
            fallback={<Checkbox checked={task.isCompleted} disabled />}
          >
            <Checkbox
              checked={isChecked}
              className="pl-0 md:pl-2"
              color="primary"
              data-testid={`task-detail-checkbox-${task.taskId}`}
              disabled={isUpdating}
              id={`task-detail-checkbox-${task.taskId}`}
              name="is-completed"
              onChange={handleChange}
              value={isChecked}
            />
          </ShowForViews>
        }
        label={translate('TASKS_MARK_AS_COMPLETE')}
      />
      <CloseButton
        className="absolute -right-3"
        onClick={onClose}
        data-testid="entity-details-close-button"
      />
    </FormGroup>
  );
}
